import * as fromCourseCategory from './courseCategory.reducer';
import { State } from './courseCategory.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const { selectAll } = fromCourseCategory.courseCategoryAdapter.getSelectors();

export const selectCourseCategoryState = createFeatureSelector<fromCourseCategory.State>(fromCourseCategory.courseCategoryFeatureKey);

export const selectAllCourseCategories = createSelector(selectCourseCategoryState, selectAll);

export const selectNewCreatedCourseCategory = createSelector(selectCourseCategoryState, (state: State) => state.entities[state.selectedCourseId]);

export const selectCourseCategoriesByName = (searchString: string) =>
    createSelector(selectAllCourseCategories, (entities) => entities.filter((entity) => entity.name?.toLowerCase().includes(searchString.toLowerCase())));
